import React from "react";
import SEO from "../components/SEO.jsx";
import Header from "../partials/header/Header.jsx";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb.js";
import Footer from "../container/Footer/Footer.js";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo.js";
// import { Link } from "react-router-dom";

const Reservation = () => {
  const show = false;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="Hotel Reservation | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Hotel Reservation"
        content="For Participants"
        contentTwo="Hotel Reservation"
        linkage="/reservation"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>

        <div classNameName="entry-header">
          <h1>Hotel Room Infomation</h1>
          There are two types of negotiated rooms available for this conference during Dec. 13-17. Each room includes breakfasts and authors are recommended to book via the Reservation Form below. 
          {/* Due to the limited number of rooms, the reservation deadline is Dec 3rd,2023. */}
          <hr></hr>
          <table>
            <thead>
              <th>Room Type</th>
              <th>|</th>
              <th>Price(RMB)</th>
              <th>|</th>
              <th>Maximum occupancy per room</th>
              <th>|</th>
              <th>Note</th>
            </thead>
            <tbody>
              <tr>
                <td>Deluxe King Bed Room with Breakfast </td>
                <td>|</td>
                <td>898</td>
                <td>|</td>
                <td>2</td>
                <td>|</td>
                <td>Include breakfast buffets</td>
              </tr>

              <tr>
                <td>Deluxe Twin Bed Room with Breakfast</td>
                <td>|</td>
                <td>898</td>
                <td>|</td>
                <td>2</td>
                <td>|</td>
                <td>Include breakfast buffets</td>
              </tr>
            </tbody>
          </table>
          <hr></hr>
          No negotiated rates for other rooms. You can book through other means. 
          <hr></hr>
          
          <br></br>
          <h1>Reservation Form(Only for Negotiated rate room)</h1>
          <div className="reg-form">
            <iframe
              src="https://wj.qq.com/s2/16254781/3hxj/"
            // frameBorder={0}
            // allowFullSreen
            ></iframe>
          </div>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classNameOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
}
else {
  return (
    <React.Fragment>
      <SEO title="Hotel Reservation | DMBD 2025s" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Hotel Reservation"
        content="For Participants"
        contentTwo="Hotel Reservation"
        linkage="/reservation"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div>
          <h3>To be released.</h3>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  )
}
};

export default Reservation;
